
// Online Assignment
export const SET_ONLINE_ASSIGNMENT = "SET_ONLINE_ASSIGNMENT"